var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.3 50.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.8.8h22.8v22.7H.8zM26.8.8h22.7v22.7H26.8zM.8 26.8h22.8v22.8H.8zM26.8 26.8h22.7v22.8H26.8z"
  })));
}
export default SvgDisplayGrid;